module.exports = "/_next/static/images/3c99e111e81cb9d09605c39c9b59a79d-careers@0.5x.jpg";